export const BM = 'forum';
export const BM_CREATE_POST = 'forum/create-post';
export const BM_CATEGORIES = 'forum/categories';
